import dayjs from 'dayjs';
import { EN_LOCAL } from '@/helpers/locale';
import i18n from '@/locale';
const WORKING_HOURS = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30',
];
const MONTHS = [
    'CALENDAR.MONTH.JANUARY',
    'CALENDAR.MONTH.FEBRUARY',
    'CALENDAR.MONTH.MARCH',
    'CALENDAR.MONTH.APRIL',
    'CALENDAR.MONTH.MAY',
    'CALENDAR.MONTH.JUNE',
    'CALENDAR.MONTH.JULY',
    'CALENDAR.MONTH.AUGUST',
    'CALENDAR.MONTH.SEPTEMBER',
    'CALENDAR.MONTH.OCTOBER',
    'CALENDAR.MONTH.NOVEMBER',
    'CALENDAR.MONTH.DECEMBER',
];
const WEEK_DAYS = [
    'CALENDAR.WEEK.SUNDAY',
    'CALENDAR.WEEK.MONDAY',
    'CALENDAR.WEEK.TUESDAY',
    'CALENDAR.WEEK.WEDNESDAY',
    'CALENDAR.WEEK.THURSDAY',
    'CALENDAR.WEEK.FRIDAY',
    'CALENDAR.WEEK.SATURDAY',
];
const MORNING_TIME = [
    'CALENDAR.TIME.08.AM',
    'CALENDAR.TIME.08.15.AM',
    'CALENDAR.TIME.08.30.AM',
    'CALENDAR.TIME.08.45.AM',
    'CALENDAR.TIME.09.AM',
    'CALENDAR.TIME.09.15.AM',
    'CALENDAR.TIME.09.30.AM',
    'CALENDAR.TIME.09.45.AM',
    'CALENDAR.TIME.10.AM',
    'CALENDAR.TIME.10.15.AM',
    'CALENDAR.TIME.10.30.AM',
    'CALENDAR.TIME.10.45.AM',
    'CALENDAR.TIME.11.AM',
    'CALENDAR.TIME.11.15.AM',
    'CALENDAR.TIME.11.30.AM',
    'CALENDAR.TIME.11.45.AM',
    'CALENDAR.TIME.12.PM',
];
const AFTERNOON_TIME = [
    'CALENDAR.TIME.02.PM',
    'CALENDAR.TIME.02.15.PM',
    'CALENDAR.TIME.02.30.PM',
    'CALENDAR.TIME.02.45.PM',
    'CALENDAR.TIME.03.PM',
    'CALENDAR.TIME.03.15.PM',
    'CALENDAR.TIME.03.30.PM',
    'CALENDAR.TIME.03.45.PM',
    'CALENDAR.TIME.04.PM',
    'CALENDAR.TIME.04.15.PM',
    'CALENDAR.TIME.04.30.PM',
    'CALENDAR.TIME.04.45.PM',
    'CALENDAR.TIME.05.PM',
    'CALENDAR.TIME.05.15.PM',
    'CALENDAR.TIME.05.30.PM',
    'CALENDAR.TIME.05.45.PM',
    'CALENDAR.TIME.06.PM',
    'CALENDAR.TIME.06.15.PM',
    'CALENDAR.TIME.06.30.PM',
    'CALENDAR.TIME.06.45.PM',
    'CALENDAR.TIME.07.PM',
];
const FULL_TIME = [
    ...MORNING_TIME,
    ...[
        'CALENDAR.TIME.12.15.PM',
        'CALENDAR.TIME.12.30.PM',
        'CALENDAR.TIME.12.45.PM',
        'CALENDAR.TIME.01.PM',
        'CALENDAR.TIME.01.15.PM',
        'CALENDAR.TIME.01.30.PM',
        'CALENDAR.TIME.01.45.PM',
    ],
    ...AFTERNOON_TIME,
];
const FULL_TIME_EVERY_15 = [
    'CALENDAR.TIME.12.AM',
    'CALENDAR.TIME.12.15.AM',
    'CALENDAR.TIME.12.30.AM',
    'CALENDAR.TIME.12.45.AM',
    'CALENDAR.TIME.01.AM',
    'CALENDAR.TIME.01.15.AM',
    'CALENDAR.TIME.01.30.AM',
    'CALENDAR.TIME.01.45.AM',
    'CALENDAR.TIME.02.AM',
    'CALENDAR.TIME.02.15.AM',
    'CALENDAR.TIME.02.30.AM',
    'CALENDAR.TIME.02.45.AM',
    'CALENDAR.TIME.03.AM',
    'CALENDAR.TIME.03.15.AM',
    'CALENDAR.TIME.03.30.AM',
    'CALENDAR.TIME.03.45.AM',
    'CALENDAR.TIME.04.AM',
    'CALENDAR.TIME.04.15.AM',
    'CALENDAR.TIME.04.30.AM',
    'CALENDAR.TIME.04.45.AM',
    'CALENDAR.TIME.05.AM',
    'CALENDAR.TIME.05.15.AM',
    'CALENDAR.TIME.05.30.AM',
    'CALENDAR.TIME.05.45.AM',
    'CALENDAR.TIME.06.AM',
    'CALENDAR.TIME.06.15.AM',
    'CALENDAR.TIME.06.30.AM',
    'CALENDAR.TIME.06.45.AM',
    'CALENDAR.TIME.07.AM',
    'CALENDAR.TIME.07.15.AM',
    'CALENDAR.TIME.07.30.AM',
    'CALENDAR.TIME.07.45.AM',
    'CALENDAR.TIME.08.AM',
    'CALENDAR.TIME.08.15.AM',
    'CALENDAR.TIME.08.30.AM',
    'CALENDAR.TIME.08.45.AM',
    'CALENDAR.TIME.09.AM',
    'CALENDAR.TIME.09.15.AM',
    'CALENDAR.TIME.09.30.AM',
    'CALENDAR.TIME.09.45.AM',
    'CALENDAR.TIME.10.AM',
    'CALENDAR.TIME.10.15.AM',
    'CALENDAR.TIME.10.30.AM',
    'CALENDAR.TIME.10.45.AM',
    'CALENDAR.TIME.11.AM',
    'CALENDAR.TIME.11.15.AM',
    'CALENDAR.TIME.11.30.AM',
    'CALENDAR.TIME.11.45.AM',
    'CALENDAR.TIME.12.PM',
    'CALENDAR.TIME.12.15.PM',
    'CALENDAR.TIME.12.30.PM',
    'CALENDAR.TIME.12.45.PM',
    'CALENDAR.TIME.01.PM',
    'CALENDAR.TIME.01.15.PM',
    'CALENDAR.TIME.01.30.PM',
    'CALENDAR.TIME.01.45.PM',
    'CALENDAR.TIME.02.PM',
    'CALENDAR.TIME.02.15.PM',
    'CALENDAR.TIME.02.30.PM',
    'CALENDAR.TIME.02.45.PM',
    'CALENDAR.TIME.03.PM',
    'CALENDAR.TIME.03.15.PM',
    'CALENDAR.TIME.03.30.PM',
    'CALENDAR.TIME.03.45.PM',
    'CALENDAR.TIME.04.PM',
    'CALENDAR.TIME.04.15.PM',
    'CALENDAR.TIME.04.30.PM',
    'CALENDAR.TIME.04.45.PM',
    'CALENDAR.TIME.05.PM',
    'CALENDAR.TIME.05.15.PM',
    'CALENDAR.TIME.05.30.PM',
    'CALENDAR.TIME.05.45.PM',
    'CALENDAR.TIME.06.PM',
    'CALENDAR.TIME.06.15.PM',
    'CALENDAR.TIME.06.30.PM',
    'CALENDAR.TIME.06.45.PM',
    'CALENDAR.TIME.07.PM',
    'CALENDAR.TIME.07.15.PM',
    'CALENDAR.TIME.07.30.PM',
    'CALENDAR.TIME.07.45.PM',
    'CALENDAR.TIME.08.PM',
    'CALENDAR.TIME.08.15.PM',
    'CALENDAR.TIME.08.30.PM',
    'CALENDAR.TIME.08.45.PM',
    'CALENDAR.TIME.09.PM',
    'CALENDAR.TIME.09.15.PM',
    'CALENDAR.TIME.09.30.PM',
    'CALENDAR.TIME.09.45.PM',
    'CALENDAR.TIME.10.PM',
    'CALENDAR.TIME.10.15.PM',
    'CALENDAR.TIME.10.30.PM',
    'CALENDAR.TIME.10.45.PM',
    'CALENDAR.TIME.11.PM',
    'CALENDAR.TIME.11.15.PM',
    'CALENDAR.TIME.11.30.PM',
    'CALENDAR.TIME.11.45.PM',
    'CALENDAR.TIME.12.AM',
];
const FULL_TIME_EVERY_30 = [
    'CALENDAR.TIME.12.AM',
    'CALENDAR.TIME.12.30.AM',
    'CALENDAR.TIME.01.AM',
    'CALENDAR.TIME.01.30.AM',
    'CALENDAR.TIME.02.AM',
    'CALENDAR.TIME.02.30.AM',
    'CALENDAR.TIME.03.AM',
    'CALENDAR.TIME.03.30.AM',
    'CALENDAR.TIME.04.AM',
    'CALENDAR.TIME.04.30.AM',
    'CALENDAR.TIME.05.AM',
    'CALENDAR.TIME.05.30.AM',
    'CALENDAR.TIME.06.AM',
    'CALENDAR.TIME.06.30.AM',
    'CALENDAR.TIME.07.AM',
    'CALENDAR.TIME.07.30.AM',
    'CALENDAR.TIME.08.AM',
    'CALENDAR.TIME.08.30.AM',
    'CALENDAR.TIME.09.AM',
    'CALENDAR.TIME.09.30.AM',
    'CALENDAR.TIME.10.AM',
    'CALENDAR.TIME.10.30.AM',
    'CALENDAR.TIME.11.AM',
    'CALENDAR.TIME.11.30.AM',
    'CALENDAR.TIME.12.PM',
    'CALENDAR.TIME.12.30.PM',
    'CALENDAR.TIME.01.PM',
    'CALENDAR.TIME.01.30.PM',
    'CALENDAR.TIME.02.PM',
    'CALENDAR.TIME.02.30.PM',
    'CALENDAR.TIME.03.PM',
    'CALENDAR.TIME.03.30.PM',
    'CALENDAR.TIME.04.PM',
    'CALENDAR.TIME.04.30.PM',
    'CALENDAR.TIME.05.PM',
    'CALENDAR.TIME.05.30.PM',
    'CALENDAR.TIME.06.PM',
    'CALENDAR.TIME.06.30.PM',
    'CALENDAR.TIME.07.PM',
    'CALENDAR.TIME.07.30.PM',
    'CALENDAR.TIME.08.PM',
    'CALENDAR.TIME.08.30.PM',
    'CALENDAR.TIME.09.PM',
    'CALENDAR.TIME.09.30.PM',
    'CALENDAR.TIME.10.PM',
    'CALENDAR.TIME.10.30.PM',
    'CALENDAR.TIME.11.PM',
    'CALENDAR.TIME.11.30.PM',
    'CALENDAR.TIME.12.AM',
];
function dateAsEventTime(date, user) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    let userLocale = 'en';
    if (user) {
        userLocale = i18n.locale;
    }
    // @ts-ignore-next-line
    return date.toLocaleDateString(userLocale, options);
}
function getDayOfWeek(date) {
    return new Date(date).toLocaleString('en-us', { weekday: 'long' });
}
function getDateAsIsoString(date, withOutDate = false) {
    const currentMonth = date.getMonth() + 1;
    let currentMonthString = currentMonth.toString();
    if (currentMonthString.length === 1) {
        currentMonthString = `0${currentMonthString}`;
    }
    let dayString = '';
    if (!withOutDate) {
        const currentDay = date.getDate();
        dayString = currentDay.toString();
        if (dayString.length === 1) {
            dayString = `0${dayString}`;
        }
        dayString = `-${dayString}`;
    }
    return `${date.getFullYear()}-${currentMonthString}${dayString}`;
}
function getIsoUTCDate(date) {
    const offset = (date).getTimezoneOffset() * 60000;
    return `${(new Date(+date - offset)).toISOString().slice(0, -4)}000Z`;
}
function getDateWithDelayInDays(date, delay, nightTime = false) {
    if (nightTime) {
        date.setHours(0, 0, 0);
    }
    return new Date(date.setDate(date.getDate() + delay));
}
/* eslint-disable-next-line no-shadow */
function getPrettyStringDate(date, i18n, withoutTimezoneCalc) {
    const sameDayAsString = withoutTimezoneCalc ? new Date(date.getTime() - date.getTimezoneOffset() * -60000) : date;
    // example: Friday, October 25, 2019
    return `${i18n.t(WEEK_DAYS[sameDayAsString.getDay()])}, ${i18n.t(MONTHS[sameDayAsString.getMonth()])} ${sameDayAsString.getDate()}, ${sameDayAsString.getFullYear()}`;
}
/* eslint-disable-next-line no-shadow */
function getStringMonthDayYearDate(date, i18n, withoutTimezoneCalc) {
    const sameDayAsString = withoutTimezoneCalc ? new Date(date.getTime() - date.getTimezoneOffset() * -60000) : date;
    // example: Friday, October 25, 2019
    return `${i18n.t(MONTHS[sameDayAsString.getMonth()])} ${sameDayAsString.getDate()}, ${sameDayAsString.getFullYear()}`;
}
function formatDateForTitle(date) {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}
function formatDateDayMonthYearByLocale(date, locale) {
    const currentDate = date.getDate();
    const currentDateText = currentDate.toString().length === 1 ? `0${currentDate.toString()}` : currentDate.toString();
    const currentMonth = date.getMonth() + 1;
    const currentMonthText = currentMonth.toString().length === 1 ? `0${currentMonth.toString()}` : currentMonth.toString();
    if (locale === EN_LOCAL) {
        return `${date.getFullYear()}-${currentMonthText}-${currentDateText}`;
    }
    return `${currentDateText}/${currentMonthText}/${date.getFullYear()}`;
}
function isValidDate(date) {
    // @ts-ignore-next-line
    // eslint-disable-next-line no-restricted-globals
    return date instanceof Date && !isNaN(date);
}
function getMinutesOrHoursAsString(value) {
    return `${value}`.length === 1 ? `0${value}` : `${value}`;
}
function formatAMPM({ date, locale, useUTC = true }) {
    let hours = useUTC ? date.getUTCHours() : date.getHours();
    let minutes = date.getMinutes();
    if (locale === EN_LOCAL) {
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours %= 12;
        hours = hours || 12;
        if (minutes === 59) {
            minutes = 0;
            hours = hours === 12 ? 12 : hours + 1;
        }
        return `${getMinutesOrHoursAsString(hours)}:${getMinutesOrHoursAsString(minutes)} ${ampm}`;
    }
    if (minutes === 59) {
        minutes = 0;
        hours = hours === 24 ? 24 : hours + 1;
    }
    return `${getMinutesOrHoursAsString(hours)}h${getMinutesOrHoursAsString(minutes)}`;
}
function parseToUTCDate(string) {
    const date = new Date(string);
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const hour = date.getUTCHours();
    const minute = date.getUTCMinutes();
    const day = date.getUTCDate();
    return new Date(year, month, day, hour, minute);
}
function getCurrentDateAsHoursAMPM({ date, locale, useUTC = true }) {
    const localDate = date || new Date();
    let hours = useUTC ? localDate.getUTCHours() : localDate.getHours();
    if (locale === EN_LOCAL) {
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours %= 12;
        hours = hours || 12;
        return `${getMinutesOrHoursAsString(hours)}:00 ${ampm}`;
    }
    return `${getMinutesOrHoursAsString(hours)}h00`;
}
function currentHoursCalculation(calculationNumber, locale) {
    const localDate = new Date();
    let hours = localDate.getHours() + calculationNumber;
    if (locale === EN_LOCAL) {
        const ampm = hours >= 12 && hours < 24 ? 'pm' : 'am';
        hours %= 12;
        hours = hours || 12; // the hour '0' should be '12'
        return `${getMinutesOrHoursAsString(hours)}:00 ${ampm}`;
    }
    return `${getMinutesOrHoursAsString(hours)}h00`;
}
function getCurrentDateAsMinutesAMPM({ date, locale, useUTC = false }) {
    const localDate = date || new Date();
    let hours = useUTC ? localDate.getUTCHours() : localDate.getHours();
    const minutes = localDate.getMinutes();
    if (locale === EN_LOCAL) {
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours %= 12;
        hours = hours || 12;
        return `${getMinutesOrHoursAsString(hours)}:${getMinutesOrHoursAsString(minutes)} ${ampm}`;
    }
    return `${getMinutesOrHoursAsString(hours)}h${getMinutesOrHoursAsString(minutes)}`;
}
function getCurrentDateAsMinutes({ date, locale, useUTC = false }) {
    const localDate = date || new Date();
    const hours = useUTC ? localDate.getUTCHours() : localDate.getHours();
    const minutes = localDate.getMinutes();
    return `${getMinutesOrHoursAsString(hours)}:${getMinutesOrHoursAsString(minutes)}`;
}
function getFirstDayOfMonth(date) {
    const localDate = date || new Date();
    return new Date(localDate.getFullYear(), localDate.getMonth(), 1);
}
function getLastDayOfMonth(date, delay = 0) {
    const localDate = date || new Date();
    return new Date(localDate.getFullYear(), localDate.getMonth() + 1, delay);
}
function getWeekNumber(date) {
    const localDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    localDate.setUTCDate(localDate.getUTCDate() + 4 - (localDate.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(localDate.getUTCFullYear(), 0, 1));
    return Math.ceil((((+localDate - +yearStart) / 86400000) + 1) / 7);
}
function getHoursAndMinutesFromAMPM(ampm) {
    // 03:00 am || 03:00 pm for En
    // 8h00 || 13h00 Fr
    if (ampm.includes('h')) {
        const timeDate = ampm.split('h');
        return {
            hours: parseInt(timeDate[0], 10),
            minutes: parseInt(timeDate[1], 10),
        };
    }
    else if (ampm.includes(':')) {
        const timeDate = ampm.split(':');
        const isPm = ampm.includes('pm');
        let hours = parseInt(timeDate[0], 10);
        if (isPm && hours < 12)
            hours += 12;
        if (!isPm && hours === 12)
            hours -= 12;
        return {
            hours,
            minutes: parseInt(timeDate[1], 10),
        };
    }
    return {
        hours: 0,
        minutes: 0,
    };
}
function formatAppointmentTime(time, locale) {
    const normalizedTime = time.toLowerCase();
    const { hours, minutes } = getHoursAndMinutesFromAMPM(normalizedTime);
    if (locale === EN_LOCAL) {
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${getMinutesOrHoursAsString(minutes)} ${ampm}`;
    }
    return `${getMinutesOrHoursAsString(hours)}h${getMinutesOrHoursAsString(minutes)}`;
}
function formatAppointmentDate(date, locale) {
    if (locale === EN_LOCAL) {
        return date.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        }).replace(',', '');
    }
    return date.toLocaleDateString(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
}
function dateToString(date, nightTime = false, useUTC = false) {
    const day = `${date.getFullYear()}-${getMinutesOrHoursAsString(date.getMonth() + 1)}-${getMinutesOrHoursAsString(date.getDate())}`;
    let time = '';
    if (nightTime) {
        time = '00:00:00';
    }
    else {
        // eslint-disable-next-line max-len
        time = `${getMinutesOrHoursAsString(useUTC ? date.getUTCHours() : date.getHours())}:${getMinutesOrHoursAsString(date.getMinutes())}:${getMinutesOrHoursAsString(date.getSeconds())}`;
    }
    return `${day}T${time}.000Z`;
}
function addMinutesMethod(time, minsToAdd) {
    function dateString(day) { return (day < 10 ? '0' : '') + day; }
    let result = null;
    if (time) {
        const piece = time.split(':');
        const totalMinutes = piece[0] * 60 + +piece[1] + +minsToAdd;
        // Handle negative values by adding 24 hours (1440 minutes) to get positive modulo
        const minutesInDay = 24 * 60;
        const normalizedMinutes = ((totalMinutes % minutesInDay) + minutesInDay) % minutesInDay;
        const dayHours = dateString(Math.floor(normalizedMinutes / 60));
        const dayMinutes = dateString(normalizedMinutes % 60);
        result = `${dayHours}:${dayMinutes}:00`;
    }
    return result;
}
function equalByDay(date, date2) {
    // eslint-disable-next-line max-len
    return (date.getDate() === date2.getDate() &&
        date.getMonth() === date2.getMonth() &&
        date.getFullYear() === date2.getFullYear());
}
function equalByTodayTomorrowWeekend(date) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const currentDay = new Date(date);
    const friday = today.getDay() === 5;
    const saturday = today.getDay() === 6;
    const sunday = new Date(today);
    const mondayAfterSunday = new Date(today);
    if (friday) {
        sunday.setDate(tomorrow.getDate() + 1);
        mondayAfterSunday.setDate(tomorrow.getDate() + 2);
    }
    if (saturday) {
        mondayAfterSunday.setDate(tomorrow.getDate() + 1);
    }
    return (equalByDay(today, currentDay) ||
        equalByDay(tomorrow, currentDay) ||
        equalByDay(sunday, currentDay) ||
        equalByDay(mondayAfterSunday, currentDay));
}
function getDayDateAtNight(date) {
    const localDate = date || new Date();
    localDate.setHours(0, 0, 0, 0);
    return localDate;
}
function timeConvertor(time) {
    const PM = !!time.match('pm');
    const AM = !!time.match('am');
    const h = !!time.match('h');
    const normal = !!time.match(':');
    let timeSplit = null;
    let hour = null;
    let min = null;
    if (PM) {
        timeSplit = time.split(':');
        hour = 12 + parseInt(timeSplit[0], 10);
        min = timeSplit[1].replace('pm', '');
    }
    else if (AM) {
        timeSplit = time.split(':');
        if (parseInt(timeSplit[0], 10) === 12) {
            hour = `24`;
        }
        else {
            hour = timeSplit[0];
        }
        min = timeSplit[1].replace('am', '');
    }
    else if (h) {
        timeSplit = time.split('h');
        hour = timeSplit[0].replace('h', ':');
        min = timeSplit[1];
    }
    else if (normal) {
        timeSplit = time.split(':');
        hour = timeSplit[0];
        min = timeSplit[1];
    }
    return `${hour}:${min}`;
}
function formatDate(time) {
    const timeHours = time.substring(0, 2);
    let result = null;
    let timeFormat = 'AM';
    let h = +timeHours;
    if (h >= 12) {
        // @ts-ignore-next-line
        h = timeHours - 12;
        timeFormat = 'PM';
    }
    if (h === 0) {
        h = 12;
    }
    if (`${h}`.length === 1) {
        result = `0${h}${timeFormat}`;
    }
    else {
        result = `${h}${timeFormat}`;
    }
    return result;
}
function getDisabledDates({ date = new Date(), nextDelta = 36, prevDelta = 0, }) {
    return {
        disablePrevDays: date ? dayjs(date).add(prevDelta, `month`).toDate() : new Date(),
        disableNextDays: date ? dayjs(date).add(nextDelta, `month`).toDate() : dayjs().add(nextDelta, `month`).toDate(),
    };
}
function needMakeRequest({ date = new Date(), beforeDelta = 12, afterDelts = 36, }) {
    const dateBefore = dayjs().subtract(beforeDelta, 'month');
    const dateAfter = dayjs().add(afterDelts, 'month');
    const isBeforeOneYear = dayjs(date).isBefore(dateBefore, 'month');
    const isAfterOneYear = dayjs(date).isAfter(dateAfter, 'month');
    return !isBeforeOneYear && !isAfterOneYear;
}
const BASE_BACK_TIME_FORMAT = 'ddd, DD MMM YYYY HH:mm:ss';
const OLD_BACK_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export { WORKING_HOURS, MONTHS, WEEK_DAYS, MORNING_TIME, AFTERNOON_TIME, FULL_TIME, FULL_TIME_EVERY_15, FULL_TIME_EVERY_30, dateAsEventTime, getDateAsIsoString, getCurrentDateAsMinutes, getDateWithDelayInDays, getPrettyStringDate, getStringMonthDayYearDate, formatDateForTitle, formatAMPM, currentHoursCalculation, getCurrentDateAsHoursAMPM, getCurrentDateAsMinutesAMPM, getHoursAndMinutesFromAMPM, getFirstDayOfMonth, getLastDayOfMonth, getMinutesOrHoursAsString, dateToString, equalByDay, equalByTodayTomorrowWeekend, parseToUTCDate, getDayDateAtNight, getIsoUTCDate, timeConvertor, formatDate, formatDateDayMonthYearByLocale, isValidDate, addMinutesMethod, getDisabledDates, needMakeRequest, formatAppointmentTime, formatAppointmentDate, BASE_BACK_TIME_FORMAT, };
